module.exports = __webpack_public_path__ + "media/images/icons/store_categories/icon-store-category-2-09b3da16a038c7460c75e33c285783f9.svg";